/* cancelled.icon.svg.js */

module.exports = {
    icon: `
            <svg viewBox="0 0 17 17" preserveAspectRatio="none">
                <path class="foreground-gl" d="M8.5,0C3.8,0,0,3.8,0,8.5S3.8,17,8.5,17S17,13.2,17,8.5S13.2,0,8.5,0z M9.8,8.5l4.6-4.6c1,1.3,1.6,2.9,1.6,4.6
                    s-0.6,3.4-1.6,4.6L9.8,8.5z M13.1,2.6L8.5,7.2L3.9,2.6C5.1,1.6,6.8,1,8.5,1S11.9,1.6,13.1,2.6z M2.6,3.9l4.6,4.6l-4.6,4.6
                    C1.6,11.9,1,10.2,1,8.5S1.6,5.1,2.6,3.9z M3.9,14.4l4.6-4.6l4.6,4.6c-1.3,1-2.9,1.6-4.6,1.6S5.1,15.4,3.9,14.4z"/>
            </svg>
        `
};
